// src/components/FormUploader.jsx
import React, { useState } from "react";
import axios from "axios";

export default function FormUploader() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await axios.post("https://localhost:7149/Upload_Form", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(res.data);
    } catch {
      setResult({ error: "Failed to process." });
    }
  };

  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-xl mb-2">Upload Form (PDF / Image / DOCX)</h2>
      <form onSubmit={onSubmit}>
        <input
          type="file"
          accept=".pdf,image/*,.docx"
          onChange={(e) => setFile(e.target.files[0])}
          className="mb-4"
        />
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Submit
        </button>
      </form>
      {result && (
        <div className="mt-4 p-2 border">
          {result.error ? (
            <p className="text-red-600">{result.error}</p>
          ) : (
            <>
              <p>
                <strong>Name:</strong> {result.name}
              </p>
              <p>
                <strong>Address:</strong> {result.address}
              </p>
              <p>
                <strong>FatherName:</strong> {result.fatherName}
              </p>
              <p>
                <strong>Mobile:</strong> {result.mobile}
              </p>
              <p>
                <strong>Adhaar:</strong> {result.adhaar}
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
